import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import App from './App';
import ConversionTables from './pages/ConversionTables';
import SmartCalculatorPage from './pages/SmartCalculatorPage';
import UnitComparisonPage from './pages/UnitComparisonPage';
import AdvancedToolsPage from './pages/AdvancedToolsPage';
import FAQ from './pages/FAQ';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import { BlogList } from './components/BlogList';
import { BlogPost } from './components/BlogPost';
import DirectConversionPage from './pages/DirectConversionPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/length" replace />} />
        <Route path="/:category" element={<App />} />
        <Route path="/:category/:conversion" element={<DirectConversionPage />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:blogId" element={<BlogPost />} />
        <Route path="/tables/:category" element={<ConversionTables />} />
        <Route path="/:category/calculator" element={<SmartCalculatorPage />} />
        <Route path="/:category/compare" element={<UnitComparisonPage />} />
        <Route path="/:category/advanced" element={<AdvancedToolsPage />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Navigate to="/length" replace />} />
      </Route>
    </Routes>
  );
}